export default __webpack_public_path__ + "static/media/backward.97fc05ae.svg";